import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom'

export const useNavigator = () => {
  const history = useHistory()
  const location = useLocation()

  const goBack = (data = {}) => {
    if (location.state?.from) {
      history.push(location.state.from, { ...location.state, ...data })
    } else {
      history.goBack()
    }
  }

  const navigateTo = (path, data = {}) => {
    history.push(path, {
      from: location.pathname,
      ...data,
    })
  }

  return {
    history,
    pathname: location.pathname,
    state: location.state,
    goBack,
    navigateTo,
    currentFrom: location.state?.from,
    fullPathname: `${location.pathname}${location?.search}`,
  }
}
